import { Routes } from '@angular/router';
import { ModulesComponent } from '../../../../Tenant/Applications/Airsweb/Module/modules/modules.component';
import { AwDiffComponent } from './aw-diff/aw-diff.component';
import { LinkedFieldTreeControlConfigurationComponent } from './linked-field-tree-control-configuration/linked-field-tree-control-configuration.component';
import { LinkedRecordConfigurationComponent } from './linked-record-configuration/linked-record-configuration.component';
import { AwLookupConfigurationFieldComponent } from './lookup-configuration-field/aw-lookup-configuration-field.component';
import { ModuleComponent } from './module.component';
import { ModuleResolveGuard } from './module.resolve-guard';
import { StateComponent } from './state/state.component';
import { NodeGraphComponent } from './node-graph-component/node-graph.component';
import { AvailabilityContainerComponent } from './step/availability/availability-container.component';
import { FieldsContainerComponent } from './step/fields/fields-container.component';
import { FieldsComponent } from './step/fields/fields.component';
import { PrimaryFieldConfigComponent } from './step/primary-field-config/primary-field-config.component';
import { RulesContainerComponent } from './step/rules/rules-container.component';
import { RulesComponent } from './step/rules/rules.component';
import { StepComponent } from './step/step.component';
import { StepResolveGuard } from './step/step.resolve-guard';
import { SubmissionTypeConfigComponent } from './step/submission-type-config/submission-type-config.component';
import { StepsComponent } from './steps/steps.component';
import { LinkedFieldsComponent } from './linked-fields/linked-fields.component';

export const AW_MODULE_ROUTES: Routes = [
    { path: '', component: ModulesComponent },
    { path: ':moduleId/:version/field/:fieldId', component: AwLookupConfigurationFieldComponent },
    { path: ':moduleId/:version/field/:fieldId/linkedrecordconfig', component: LinkedRecordConfigurationComponent },
    { path: ':moduleId/:version/tree-configuration/:stepId/:fieldId', component: LinkedFieldTreeControlConfigurationComponent },
    { path: ':moduleId/:version/diff', component: AwDiffComponent },
    {
        path: ':moduleId/:version',
        component: ModuleComponent,
        resolve: {
            moduleData: ModuleResolveGuard
        },
        runGuardsAndResolvers: 'pathParamsChange',
        children: [
            { path: '', redirectTo: 'steps', pathMatch: 'full' },
            {
                path: 'steps', component: StepsComponent,
                children: [{
                    path: 'step',
                    component: StepComponent,
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                    resolve: {
                        stepData: StepResolveGuard,
                    },
                    children: [
                        { path: '', redirectTo: 'fields-container', pathMatch: 'full' },
                        {
                            path: 'fields-container',
                            component: FieldsContainerComponent,
                            children: [
                                { path: '', redirectTo: 'parent-fields', pathMatch: 'full' },
                                { path: 'parent-fields', component: FieldsComponent },
                                { path: 'multiple-entries', component: FieldsComponent }
                            ]
                        },
                        {
                            path: 'rules-container', component: RulesContainerComponent,
                            children: [
                                { path: '', redirectTo: 'indicator-rules', pathMatch: 'full' },
                                { path: 'indicator-rules', component: RulesComponent },
                                { path: 'multiple-entries', component: RulesComponent }
                            ]
                        },
                        {
                            path: 'availability-container', component: AvailabilityContainerComponent
                        },
                        { path: 'submission-type-config', component: SubmissionTypeConfigComponent },
                        { path: 'primary-field-config', component: PrimaryFieldConfigComponent }
                    ]
                }]
            },
            { path: 'state', component: StateComponent },
            { path: 'linkedfields', component: LinkedFieldsComponent },
            { path: 'stateviewer', component: NodeGraphComponent },
        ]
    }
];
